import { getAssetPublicUrl } from "../api/assets";
import { handoutIconSize } from "./handoutAssets";

export const HANDOUT_WORD_PRESET = "junior_word_b1";
export const handoutWordAssetPrefix = "素材/國中講義素材/政3內文圖示素材/";
export const handoutGrayFocusAssetUrl = getAssetPublicUrl(handoutWordAssetPrefix + "05_重點外框/觀念底_淺灰紋理_左上斜角.png");
export const isHandoutWordLayout = (settings) => settings?.layoutPreset === HANDOUT_WORD_PRESET;
export const getHandoutFocusBackgroundStyle = (section, settings) =>
  (section?.focusBackgroundStyle || settings?.focus?.backgroundStyle) === "frame" ? "frame" : "gray";

export const normalizeHandoutHeaderFooter = (settings, defaults = {}) => {
  const saved = settings?.headerFooter || {};
  return { ...defaults, ...saved,
    differentOddEvenPages: isHandoutWordLayout(settings) || (saved.differentOddEvenPages ??
      Object.entries(saved).some(([key, value]) => /^(odd|even)/.test(key) && Boolean(value))),
    ...(isHandoutWordLayout(settings) ? { pageNumberPosition: ["outer", "inner", "center", "none"].includes(saved.pageNumberPosition) ? saved.pageNumberPosition : "outer" } : {}),
  };
};

const icon = (relative, width_cm, height_cm) => {
  const key = handoutWordAssetPrefix + relative;
  return { key, name: relative.split("/").pop(), url: getAssetPublicUrl(key), width_cm, height_cm };
};
export const handoutWordDefaultIcons = {
  chapter: icon("02_單元標題/單元_立方體_編號留白.png", 4.64, 2),
  focus: icon("03_教學標籤/重點整理_書本.png", 4.15, 1.36),
  type: icon("04_題型標題/題型01_文具筒.png", 2.5, 1.04),
  practice: icon("03_教學標籤/類題_圓規.png", 2, 0.76),
  wave: icon("08_分隔裝飾/題型分隔線_捲曲波浪_短版.png", 11.5, 0.93),
};

export const applyHandoutWordLayout = (settings) => ({
  ...settings,
  layoutPreset: HANDOUT_WORD_PRESET,
  headerFooter: normalizeHandoutHeaderFooter({ ...settings, layoutPreset: HANDOUT_WORD_PRESET }),
  bodyFontName: "標楷體", bodyFontSize: 12, headingFontName: "標楷體", headingFontSize: 16, titleFontSize: 25, lineSpacing: 1.25,
  optionsLayout: settings.optionsLayout || "auto",
  questionFigureLayout: settings.questionFigureLayout || "below",
  questionSpacingPt: settings.questionSpacingPt ?? 0,
  answerFontSize: settings.answerFontSize ?? 12,
  answerBold: settings.answerBold ?? false,
  preserveManualPageBreaks: settings.preserveManualPageBreaks ?? true,
  iconPrefix: handoutWordAssetPrefix,
  icons: { ...handoutWordDefaultIcons, ...settings.icons },
  focus: { ...settings.focus, backgroundStyle: settings.focus?.backgroundStyle || "gray", frame: settings.focus?.frame || {
    url: getAssetPublicUrl(handoutWordAssetPrefix + "05_重點外框/重點外框_雙線斜角_橫式_2284x1749.png"),
  } },
});

// The compact handout uses the existing plain Word renderer, like the GM
// practice handouts. Clear decorative assets carried over from the B1 preset.
export const applyHandoutSimpleLayout = (settings) => ({
  ...settings,
  layoutPreset: "",
  margins: { top: 1, bottom: 1, left: 1, right: 1, gutter: 0 },
  bodyFontName: "標楷體", bodyFontSize: 14,
  headingFontName: "標楷體", headingFontSize: 14,
  titleFontSize: 20, lineSpacing: 1.25,
  headerFooter: { ...settings.headerFooter, differentOddEvenPages: false },
  icons: {},
  focus: { ...settings.focus, frame: undefined, backgroundStyle: undefined, backgroundRendering: undefined,
    grayAssetURL: undefined, gray_asset: undefined },
});

export const getHandoutWordIcon = (settings, role, number) => {
  const selected = settings?.icons?.[role];
  if (!selected?.url) return null;
  const size = handoutIconSize(selected, isHandoutWordLayout(settings) ? handoutWordDefaultIcons[role] : {});
  const value = Number(number);
  let sourceName = selected.key || selected.url;
  try { sourceName = decodeURIComponent(sourceName); } catch { /* Keep literal names if a URL has an unmatched escape. */ }
  if (role === "type" && Number.isInteger(value) && value >= 1 && value <= 20 &&
    /題型\d+_文具筒\.png$/.test(sourceName)) {
    return { ...selected, ...icon(`04_題型標題/題型${String(value).padStart(2, "0")}_文具筒.png`, size.width_cm || 2.5, size.height_cm || 1.04) };
  }
  return { ...selected, ...size };
};

export const handoutIconPreviewStyle = (icon) => {
  const { width_cm, height_cm } = handoutIconSize(icon);
  return width_cm || height_cm ? { width: width_cm ? `${width_cm}cm` : "auto", height: height_cm ? `${height_cm}cm` : "auto" } : undefined;
};

export const getHandoutFocusCaption = (title) => String(title || "").replace(/[\s\u3000]*重點整理(?=（續）$|\(續\)$|$)/u, "").trim();

export const hasHandoutSectionHeading = (section, settings) => Boolean(section.title || settings.focus?.typeTitle ||
  (isHandoutWordLayout(settings) ? ["type", "practice"].includes(section.heading?.role) : settings.icons?.type));
